import { useEffect } from 'react';
export function useTitle(title) {
    useEffect(() => {
        const prevTitle = document.title
        document.title = title == null ? process.env.REACT_APP_TITLE : title ;
        return () => {
            document.title = prevTitle
        }
    }, [title])
}